import StaticDataSource from './StaticDataSource';
import EMPLOYMENT_STATUSES from 'main/stores/employees/employmentStatuses';
import EMPLOYMENT_TYPES from 'main/stores/employees/employmentTypes';
import GENDERS from 'main/stores/employees/genders';
import TERMINATION_TYPES from 'main/stores/employees/terminationTypes';
import CANDIDATE_STATUSES from 'main/stores/recruiting/candidateStatuses';
import POSITION_STATUSES from 'main/stores/recruiting/positionStatuses';
import TASK_TYPES from 'main/stores/tasks/taskTypes';
import EXPENSE_STATUSES from 'main/stores/expenses/expenseStatuses';
import TIME_OFF_REQUEST_STATUSES from 'main/stores/time_off/timeOffRequestStatuses';

class BaseReportDataSource {
  customReportId;

  constructor(customReportId) {
    this.customReportId = customReportId;
  }

  departmentDataSource() {
    throw new Error('departmentDataSrouce() undefined in subclass');
  }

  locationDataSource() {
    throw new Error('locationsDataSource() undefined in subclass');
  }

  employeeDataSource() {
    throw new Error('employeeDatSource() undefined in subclass');
  }

  managerDataSource() {
    throw new Error('managerDataSource() undefined in subclass');
  }

  positionDataSource() {
    throw new Error('positionDataSource() undefined in subclass');
  }

  documentDataSource() {
    throw new Error('documentDataSource() undefined in subclass');
  }

  terminatedEmployeeDataSource() {
    throw new Error('terminatedEmployeeDataSource() undefined in subclass');
  }

  timeOffTypeDataSource() {
    throw new Error('timeOffTypeDataSource() undefined in subclass');
  }

  userDataSource() {
    throw new Error('userDataSource() undefined in subclass');
  }

  employmentStatusDataSource() {
    return new StaticDataSource(EMPLOYMENT_STATUSES);
  }

  employmentTypeDataSource() {
    return new StaticDataSource(EMPLOYMENT_TYPES);
  }

  genderDataSource() {
    return new StaticDataSource(GENDERS);
  }

  terminationTypeDataSource() {
    return new StaticDataSource(TERMINATION_TYPES);
  }

  candidateStatusDataSource() {
    return new StaticDataSource(CANDIDATE_STATUSES);
  }

  positionStatusDataSource() {
    return new StaticDataSource(POSITION_STATUSES);
  }

  taskTypeDataSource() {
    return new StaticDataSource(TASK_TYPES);
  }

  expenseStatusDataSource() {
    return new StaticDataSource(EXPENSE_STATUSES);
  }

  timeOffRequestStatusDataSource() {
    return new StaticDataSource(TIME_OFF_REQUEST_STATUSES);
  }
}

export default BaseReportDataSource;
